import React from 'react';
import { Star } from 'lucide-react';

const STAR_VALUES = [1, 2, 3, 4, 5];

export const StarRating = ({ rating, size = 14, className = 'text-saffron fill-saffron' }) => (
  <>
    {STAR_VALUES.filter(n => n <= rating).map(n => (
      <Star key={n} size={size} className={className} />
    ))}
  </>
);
